import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "workflow-tabs-row mb-1" }
const _hoisted_2 = { class: "workflow-tab-scroll" }
const _hoisted_3 = { class: "d-flex align-center justify-space-between mb-1 step-toolbar" }
const _hoisted_4 = { class: "text-overline" }
const _hoisted_5 = { class: "text-subtitle-2" }
const _hoisted_6 = { class: "factory-section-shell mt-2 mb-2" }
const _hoisted_7 = { class: "factory-section-header pa-3 d-flex justify-space-between align-center" }
const _hoisted_8 = { class: "factory-section-body" }
const _hoisted_9 = {
  key: 0,
  class: "visual-payload-editor factory-schema-visual-editor"
}
const _hoisted_10 = { class: "workflow-result-tab" }
const _hoisted_11 = { class: "workflow-tab-scroll" }
const _hoisted_12 = { class: "d-flex align-center justify-space-between mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_FactorySchemaNode = _resolveComponent("FactorySchemaNode")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_FactoryRunBrowser = _resolveComponent("FactoryRunBrowser")!
  const _component_FactoryScheduleCard = _resolveComponent("FactoryScheduleCard")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.localFactory)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "pa-0 workflow-editor-shell",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "workflow-header-row ma-0",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-0 pr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    class: "my-0 mt-2",
                    label: "Factory Name",
                    modelValue: _ctx.localFactory.name,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFactory.name) = $event)),
                      _ctx.scheduleTextFieldSave
                    ],
                    onBlur: _ctx.saveTextFieldsNow,
                    variant: "outlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pa-0 text-right d-flex align-center justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    density: "compact",
                    onClick: _ctx.runFactory,
                    loading: _ctx.isRunning
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Run Factory")
                    ])),
                    _: 1,
                    __: [10]
                  }, 8, ["onClick", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.activeFactoryTab,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeFactoryTab) = $event)),
              density: "compact",
              class: "workflow-subtabs",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "runs",
                  density: "compact"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Runs")
                  ])),
                  _: 1,
                  __: [11]
                }),
                _createVNode(_component_v_tab, {
                  value: "config",
                  density: "compact"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("Config")
                  ])),
                  _: 1,
                  __: [12]
                }),
                _createVNode(_component_v_tab, {
                  value: "schedules",
                  density: "compact"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Schedules")
                  ])),
                  _: 1,
                  __: [13]
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_v_window, {
            modelValue: _ctx.activeFactoryTab,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeFactoryTab) = $event)),
            class: "workflow-editor-window"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, {
                value: "config",
                class: "workflow-window-item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_row, {
                      density: "compact",
                      class: "factory-row-tight mt-0 mb-4 mx-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              class: "my-0 mt-2",
                              label: "Description",
                              modelValue: _ctx.localFactory.description,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFactory.description) = $event)),
                                _ctx.scheduleTextFieldSave
                              ],
                              onBlur: _ctx.saveTextFieldsNow,
                              "auto-grow": "",
                              rows: "2",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      density: "compact",
                      class: "factory-row-tight mt-0 mb-4 mx-0 factory-controls-row"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.localFactory.continuous,
                              "onUpdate:modelValue": [
                                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFactory.continuous) = $event)),
                                _ctx.saveNow
                              ],
                              label: "Continuous",
                              color: "primary",
                              density: "compact",
                              "hide-details": "",
                              class: "my-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "pa-0 pr-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.localFactory.limitTotalInvocations,
                              "onUpdate:modelValue": [
                                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFactory.limitTotalInvocations) = $event)),
                                _ctx.saveNow
                              ],
                              label: "Limit Total Factory Runs",
                              color: "primary",
                              density: "compact",
                              "hide-details": "",
                              class: "my-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_number_input, {
                              modelValue: _ctx.localFactory.maxTotalInvocations,
                              "onUpdate:modelValue": [
                                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFactory.maxTotalInvocations) = $event)),
                                _ctx.saveNow
                              ],
                              label: "Max Factory Runs",
                              min: 1,
                              max: 100000,
                              "control-variant": "stacked",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              class: "my-0",
                              disabled: _ctx.localFactory.limitTotalInvocations !== true
                            }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.localFactory.continuous)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 0,
                          type: "warning",
                          density: "compact",
                          variant: "tonal",
                          class: "my-1 py-1"
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" This factory is continuous. It will execute until paused or cancelled. If the total-run cap is enabled, it stops after the configured number of completed full passes when the last step finishes. Per-step limits still apply separately. ")
                          ])),
                          _: 1,
                          __: [14]
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, {
                      density: "compact",
                      class: "factory-row-tight mt-0 mb-4 mx-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              modelValue: _ctx.manualInitialCarryPayload,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.manualInitialCarryPayload) = $event)),
                              class: "my-0 mt-2",
                              label: "Initial Payload",
                              hint: "This is sent into the first step when you run the factory manually.",
                              "persistent-hint": "",
                              "auto-grow": "",
                              rows: "2",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, "Steps (" + _toDisplayString(_ctx.localFactory.steps.length) + ")", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFactory.steps, (step, index) => {
                      return (_openBlock(), _createBlock(_component_v_card, {
                        key: step.stepId,
                        variant: "outlined",
                        class: "mb-8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center py-2 px-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_5, _toDisplayString(step.name || `Step ${index + 1}`), 1),
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                density: "compact",
                                class: "ml-2",
                                color: "primary",
                                variant: "tonal"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(step.kind), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                size: "x-small",
                                density: "compact",
                                variant: "text",
                                icon: "mdi-arrow-up",
                                disabled: index === 0,
                                onClick: ($event: any) => (_ctx.moveStep(index, -1))
                              }, null, 8, ["disabled", "onClick"]),
                              _createVNode(_component_v_btn, {
                                size: "x-small",
                                density: "compact",
                                variant: "text",
                                icon: "mdi-arrow-down",
                                disabled: index === _ctx.localFactory.steps.length - 1,
                                onClick: ($event: any) => (_ctx.moveStep(index, 1))
                              }, null, 8, ["disabled", "onClick"]),
                              _createVNode(_component_v_btn, {
                                size: "x-small",
                                density: "compact",
                                variant: "text",
                                icon: "mdi-delete-outline",
                                color: "error",
                                onClick: ($event: any) => (_ctx.confirmStepDelete(index))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_card_text, { class: "pa-2 mx-1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                density: "compact",
                                class: "factory-row-tight ma-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "py-2 pr-2 pl-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: step.name,
                                        "onUpdate:modelValue": [($event: any) => ((step.name) = $event), _ctx.scheduleLightSave],
                                        label: "Step Name",
                                        "hide-details": "",
                                        variant: "outlined",
                                        density: "compact",
                                        class: "my-0 mt-2"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "py-2 px-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        "model-value": step.kind,
                                        items: _ctx.stepKindItems,
                                        label: "Kind",
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "my-0 mt-2",
                                        "onUpdate:modelValue": ($event: any) => (_ctx.onStepKindValueChanged(step, $event))
                                      }, null, 8, ["model-value", "items", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "7",
                                    class: "py-2 pr-0 pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (step.kind === 'agent')
                                        ? (_openBlock(), _createBlock(_component_v_select, {
                                            key: 0,
                                            modelValue: step.agentRef!.agentRef,
                                            "onUpdate:modelValue": [($event: any) => ((step.agentRef!.agentRef) = $event), _ctx.saveNow],
                                            items: _ctx.agentSelectItems,
                                            "item-title": "title",
                                            "item-value": "value",
                                            label: "Agent",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "",
                                            class: "my-0 mt-2"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]))
                                        : (_openBlock(), _createBlock(_component_v_select, {
                                            key: 1,
                                            modelValue: step.workflowRef!.workflowConfigId,
                                            "onUpdate:modelValue": [($event: any) => ((step.workflowRef!.workflowConfigId) = $event), _ctx.saveNow],
                                            items: _ctx.workflowSelectItems,
                                            "item-title": "title",
                                            "item-value": "value",
                                            label: "Workflow",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "",
                                            class: "my-0 mt-2"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (step.kind === 'workflow')
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    density: "compact",
                                    class: "factory-row-tight ma-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "pa-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "factory-section-title" }, "Payload Schema", -1)),
                                              _createVNode(_component_v_btn_toggle, {
                                                class: "factory-section-toggle",
                                                "model-value": _ctx.schemaViewModes[step.stepId] || 'visual',
                                                mandatory: "",
                                                density: "compact",
                                                variant: "outlined",
                                                "onUpdate:modelValue": ($event: any) => (_ctx.onSchemaViewModeChanged(step.stepId, $event))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, { value: "visual" }, {
                                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                      _createTextVNode("Visual")
                                                    ])),
                                                    _: 1,
                                                    __: [15]
                                                  }),
                                                  _createVNode(_component_v_btn, {
                                                    value: "json",
                                                    disabled: !!_ctx.schemaErrors[step.stepId]
                                                  }, {
                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                      _createTextVNode("Raw")
                                                    ])),
                                                    _: 2,
                                                    __: [16]
                                                  }, 1032, ["disabled"])
                                                ]),
                                                _: 2
                                              }, 1032, ["model-value", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                              ((_ctx.schemaViewModes[step.stepId] || 'visual') === 'visual')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-3" }, " Start with the example field below and adjust the type, requirement, or description for the workflow input you expect. ", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schemaFieldDrafts[step.stepId] || [], (field, fieldIndex) => {
                                                      return (_openBlock(), _createBlock(_component_FactorySchemaNode, {
                                                        key: field.id,
                                                        field: field,
                                                        depth: 0,
                                                        onUpdate: ($event: any) => (_ctx.updateRootSchemaField(step, fieldIndex, $event)),
                                                        onDelete: ($event: any) => (_ctx.removeRootSchemaField(step, fieldIndex))
                                                      }, null, 8, ["field", "onUpdate", "onDelete"]))
                                                    }), 128)),
                                                    _createVNode(_component_v_btn, {
                                                      size: "small",
                                                      variant: "tonal",
                                                      "prepend-icon": "mdi-plus",
                                                      onClick: ($event: any) => (_ctx.addSchemaField(step))
                                                    }, {
                                                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                        _createTextVNode("Add Field")
                                                      ])),
                                                      _: 2,
                                                      __: [18]
                                                    }, 1032, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createBlock(_component_v_textarea, {
                                                    key: 1,
                                                    "model-value": _ctx.schemaDrafts[step.stepId] || '',
                                                    label: "Payload Schema (JSON)",
                                                    "auto-grow": "",
                                                    rows: "6",
                                                    variant: "outlined",
                                                    density: "compact",
                                                    class: "my-0",
                                                    "error-messages": _ctx.schemaErrors[step.stepId] ? [_ctx.schemaErrors[step.stepId]] : [],
                                                    "onUpdate:modelValue": ($event: any) => (_ctx.onSchemaDraftChanged(step.stepId, $event)),
                                                    onBlur: ($event: any) => (_ctx.commitSchemaDraft(step))
                                                  }, null, 8, ["model-value", "error-messages", "onUpdate:modelValue", "onBlur"]))
                                            ])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_expansion_panels, {
                                density: "compact",
                                variant: "accordion",
                                elevation: "0",
                                class: "mt-0 mb-2 factory-options-panels"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel, { class: "factory-options-panel" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, { class: "expansion-panel-title pa-3" }, {
                                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                                          _createTextVNode("Options")
                                        ])),
                                        _: 1,
                                        __: [20]
                                      }),
                                      _createVNode(_component_v_expansion_panel_text, null, {
                                        default: _withCtx(() => [
                                          (step.kind === 'agent')
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 0,
                                                density: "compact",
                                                class: "factory-row-tight ma-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "8",
                                                    class: "pa-0 pr-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_textarea, {
                                                        modelValue: step.agentRef!.promptOverride,
                                                        "onUpdate:modelValue": [($event: any) => ((step.agentRef!.promptOverride) = $event), _ctx.scheduleTextFieldSave],
                                                        label: "Prompt Override",
                                                        "auto-grow": "",
                                                        rows: "2",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2",
                                                        onBlur: _ctx.saveTextFieldsNow
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "pa-0 pl-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: step.limitStepInvocations,
                                                        "onUpdate:modelValue": [($event: any) => ((step.limitStepInvocations) = $event), _ctx.saveNow],
                                                        label: "Limit Step Runs",
                                                        color: "primary",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                      _createVNode(_component_v_number_input, {
                                                        modelValue: step.maxStepInvocations,
                                                        "onUpdate:modelValue": [($event: any) => ((step.maxStepInvocations) = $event), _ctx.scheduleLightSave],
                                                        label: "Max Step Invocations",
                                                        min: 1,
                                                        max: 10000,
                                                        "control-variant": "stacked",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2",
                                                        disabled: step.limitStepInvocations !== true
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : (_openBlock(), _createBlock(_component_v_row, {
                                                key: 1,
                                                density: "compact",
                                                class: "factory-row-tight ma-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "8",
                                                    class: "pa-0 pr-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_select, {
                                                        modelValue: step.workflowRef!.fixerAgentRef,
                                                        "onUpdate:modelValue": [($event: any) => ((step.workflowRef!.fixerAgentRef) = $event), _ctx.saveNow],
                                                        items: _ctx.agentSelectItems,
                                                        "item-title": "title",
                                                        "item-value": "value",
                                                        label: "Fixer Agent",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2",
                                                        clearable: ""
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                                                      _createVNode(_component_v_number_input, {
                                                        modelValue: step.workflowRef!.maxRepairAttempts,
                                                        "onUpdate:modelValue": [($event: any) => ((step.workflowRef!.maxRepairAttempts) = $event), _ctx.saveNow],
                                                        label: "Repair Attempts",
                                                        min: 0,
                                                        max: 5,
                                                        "control-variant": "stacked",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "pa-0 pl-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: step.limitStepInvocations,
                                                        "onUpdate:modelValue": [($event: any) => ((step.limitStepInvocations) = $event), _ctx.saveNow],
                                                        label: "Limit Step Runs",
                                                        color: "primary",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                      _createVNode(_component_v_number_input, {
                                                        modelValue: step.maxStepInvocations,
                                                        "onUpdate:modelValue": [($event: any) => ((step.maxStepInvocations) = $event), _ctx.scheduleLightSave],
                                                        label: "Max Step Invocations",
                                                        min: 1,
                                                        max: 10000,
                                                        "control-variant": "stacked",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        class: "my-0 mt-2",
                                                        disabled: step.limitStepInvocations !== true
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, {
                                density: "compact",
                                class: "factory-row-tight mt-4 mb-0 mx-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        "model-value": step.transition.kind,
                                        items: _ctx.transitionKindItems,
                                        label: "Transition",
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "my-0",
                                        "onUpdate:modelValue": ($event: any) => (_ctx.onTransitionKindValueChanged(step, $event))
                                      }, null, 8, ["model-value", "items", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (step.transition.kind === 'loop_to_index')
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "4",
                                        class: "pa-0 pl-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            "model-value": step.transition.targetIndex,
                                            items: _ctx.loopTargetItems,
                                            label: "Loop Target",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "",
                                            class: "my-0",
                                            "onUpdate:modelValue": ($event: any) => (_ctx.onLoopTargetChanged(step, Number($event)))
                                          }, null, 8, ["model-value", "items", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_col, {
                                    cols: step.transition.kind === 'loop_to_index' ? 4 : 8,
                                    class: "pa-0 d-flex justify-end align-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        variant: "outlined",
                                        "prepend-icon": "mdi-plus",
                                        class: "px-3",
                                        onClick: ($event: any) => (_ctx.insertStepAt(index + 1))
                                      }, {
                                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                                          _createTextVNode(" Add Step ")
                                        ])),
                                        _: 2,
                                        __: [21]
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1032, ["cols"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: "runs",
                class: "workflow-window-item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.localFactory)
                      ? (_openBlock(), _createBlock(_component_FactoryRunBrowser, {
                          key: 0,
                          "factory-id": _ctx.localFactory.id,
                          "factory-name": _ctx.localFactory.name,
                          "live-run-state": _ctx.factoryStreamState,
                          onPause: _ctx.pauseFactory,
                          onResume: _ctx.resumeFactory,
                          onCancel: _ctx.cancelFactory
                        }, null, 8, ["factory-id", "factory-name", "live-run-state", "onPause", "onResume", "onCancel"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: "schedules",
                class: "workflow-window-item"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-overline" }, "Schedules", -1)),
                      _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "outlined",
                        "prepend-icon": "mdi-plus",
                        class: "px-3",
                        onClick: _ctx.createSchedule
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode("Add Schedule")
                        ])),
                        _: 1,
                        __: [22]
                      }, 8, ["onClick"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules, (schedule) => {
                      return (_openBlock(), _createBlock(_component_FactoryScheduleCard, {
                        key: schedule.id,
                        schedule: schedule,
                        "factory-id": _ctx.localFactory.id,
                        onSave: _ctx.saveSchedule,
                        onToggle: _ctx.toggleSchedule,
                        onDelete: _ctx.deleteSchedule
                      }, null, 8, ["schedule", "factory-id", "onSave", "onToggle", "onDelete"]))
                    }), 128)),
                    (_ctx.draftSchedule)
                      ? (_openBlock(), _createBlock(_component_FactoryScheduleCard, {
                          key: 0,
                          schedule: _ctx.draftSchedule,
                          "factory-id": _ctx.localFactory.id,
                          "is-new": true,
                          onSave: _ctx.saveSchedule,
                          onCancelNew: _cache[7] || (_cache[7] = ($event: any) => (_ctx.draftSchedule = null))
                        }, null, 8, ["schedule", "factory-id", "onSave"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_ConfirmationDialog, {
            modelValue: _ctx.showDeleteConfirmation,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDeleteConfirmation) = $event)),
            title: "Confirm Step Deletion",
            message: "Are you sure you want to delete this step?",
            onConfirm: _ctx.deletePendingStep,
            onCancel: _ctx.clearPendingStepDelete
          }, null, 8, ["modelValue", "onConfirm", "onCancel"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}